import { NgIf, NgClass, DatePipe } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';

@Component({
    selector: 'app-oa-removed-save',
    imports: [TableModule, DropdownModule, FormsModule, NgIf, NgClass, DatePipe],
    templateUrl: './oa-removed-save.component.html',
    styleUrl: './oa-removed-save.component.scss'
})
export class OaRemovedSaveComponent {
@Input() OaRemovedData: any;
removedOaData: any[] = [];
loading: boolean = false;
ngOnChanges(changes: SimpleChanges): void {
  if (changes['OaRemovedData']) {
    if (this.OaRemovedData) {
      this.processOAData();
    }
  }
}
constructor(private router: Router){
  
}

processOAData(){
  this.removedOaData = this.OaRemovedData.tblOAAssignedToMe_Removed;
  this.removedOaData.map((item: any) => {
    if (item.tlr_status === 'I') {
      item.status = 'Installed';
      item.cssClass = 'green'
    } else if (item.tlr_status === 'P') {
      item.status = 'Pre Installation';
      item.cssClass = 'blue'
    } else if (item.tlr_status === 'R') {
      item.status = 'Removed';
      item.cssClass = 'red'
    }
  });

}
details(row : any){
  this.router.navigate(['/details-section', row.tag_number]);
}
editOa(row : any){
  this.router.navigate(['/oa-compliance-details-section', row.tag_number]);
}
}
